import React from 'react'
import PropTypes from 'prop-types'
import SelectField from '../SelectField/SelectField'
import './DestinationSelector.scss'

const DestinationSelector = ({
  id,
  setSelectedAirport,
  inboundAirports,
  outboundAirports,
  selectedInboundAirport,
  selectedOutboundAirport,
  showInputFeedback,
  inboundErrorMessage,
  outboundErrorMessage,
  labels,
  isMultipleDestination,
}) => {
  return (
    <div className="destinationSelector">
      <div
        data-element={id}
        className={
          isMultipleDestination ? 'multipleDestination' : 'singleDestination'
        }
      >
        <SelectField
          dataElement={`${id}-outbound`}
          label={labels.fromLabel}
          placeholder={labels.fromPlaceholder}
          options={outboundAirports}
          selectedItem={selectedOutboundAirport}
          handleChange={airport => setSelectedAirport(airport, 'outbound', id)}
          autoComplete={true}
          errorMessage={showInputFeedback ? outboundErrorMessage : null}
        />
        <SelectField
          dataElement={`${id}-inbound`}
          label={labels.toLabel}
          placeholder={labels.toPlaceholder}
          options={inboundAirports}
          selectedItem={selectedInboundAirport}
          handleChange={airport => setSelectedAirport(airport, 'inbound', id)}
          autoComplete={true}
          errorMessage={showInputFeedback ? inboundErrorMessage : null}
        />
      </div>
    </div>
  )
}

DestinationSelector.propTypes = {
  setSelectedAirport: PropTypes.func.isRequired,
  inboundAirports: PropTypes.array,
  outboundAirports: PropTypes.array,
  selectedInboundAirport: PropTypes.object.isRequired,
  selectedOutboundAirport: PropTypes.object.isRequired,
  labels: PropTypes.shape({
    fromPlaceholder: PropTypes.string,
    toPlaceholder: PropTypes.string,
    toLabel: PropTypes.string,
    fromLabel: PropTypes.string,
  }),
  id: PropTypes.string,
  isMultipleDestination: PropTypes.bool,
  showInputFeedback: PropTypes.bool,
  inboundErrorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  outboundErrorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default DestinationSelector
